"use client"

import {
  InfiniteTable,
  ItemType,
  type TableRowType,
  TableSkeleton,
} from "@/app/components/infinite-table/infinite-table"
import { Row as BaseTableRow, HeaderRow } from "@/app/components/table"
import { NFTSelectionToggle } from "@/app/nft/sell/selection/nft-selection-toggle.reatom"
import type { NftMiniature } from "@anaconda/core/nft/types"
import { reatomComponent } from "@reatom/react"
import { Cell } from "./cells"
import { COLUMNS } from "./columns"
import { useTableItems } from "./use-table-items"

const COMPONENTS = {
  HeaderRow: NftHeaderRow,
  RowContent,
  RowSkeleton,
  TableRow,
} as const

const getItemKey = (item: NftMiniature) => item.id

export const NftSelectorTable = reatomComponent(() => {
  const { items, loadNext } = useTableItems()

  return (
    <InfiniteTable
      getItemKey={getItemKey}
      items={items}
      loadNext={loadNext}
      components={COMPONENTS}
    />
  )
}, "NftSelectorTable")

export function NftSelectorTableSkeleton() {
  return <TableSkeleton HeaderRow={NftHeaderRow} RowSkeleton={RowSkeleton} />
}

function NftHeaderRow() {
  return (
    <HeaderRow className="border-none">
      {COLUMNS.map((column, index) => (
        <column.Header key={index} />
      ))}
    </HeaderRow>
  )
}

function RowContent({ content }: { content: NftMiniature }) {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <column.Content key={index} {...content} />
      ))}
    </>
  )
}

function RowSkeleton() {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Skeleton />
        </Cell>
      ))}
    </>
  )
}

function TableRow(props: React.ComponentProps<TableRowType<NftMiniature>>) {
  if (props.item.type === ItemType.CONTENT) {
    return (
      <NFTSelectionToggle nft={props.item.content}>
        <BaseTableRow {...props} />
      </NFTSelectionToggle>
    )
  }

  return <BaseTableRow {...props} />
}
